<template>
    <div id="file-preview-modal-container" v-if="!hidden" :class="{opened: !hidden}">
        <h1>{{ title }}</h1>
        <div class="image-container" v-if="is_pdf">
            <div class="canvas-container">
                <canvas id="pdf-canvas"></canvas>
            </div>

            <div class="pdf-controls">
                <div class="page-numbers">
                    <span>Page: <span id="page_num"></span> / <span id="page_count"></span></span>
                </div>
                <button id="prev">Previous</button>
                <button id="next">Next</button>
                <div class="zoom-controls">
                    <button id="zoomin"><i class="fa fa-plus"></i></button>
                    <button id="zoomout"><i class="fa fa-minus"></i></button>
                </div>
                <div class="download-controls">
                    <button @click.prevent="downloadPdf()"><i class="fa fa-cloud"></i> Download</button>
                </div>
            </div>
        </div>
        <div class="image-container" v-else :style="{ backgroundImage: 'url(' + image + ')' }"></div>
        <a href="#" @click.prevent="closeModal()"><i class="fa fa-times"></i></a>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title: '',
                image: '#',
                fileArrayKey: null,
                hidden: true,
                is_pdf: false,
            }
        },
        computed: {},
        methods: {
            closeModal() {
                this.title = '';
                this.image = '#';
                this.fileArrayKey = null;
                this.hidden = true;
                this.is_pdf = false;
            },
            openModal() {
                this.hidden = false;
            },
            downloadPdf(){
                eventBus.$emit('file-preview-force-download', this.fileArrayKey)
            },
            setupPdf() {
                var url = this.image;
                var pdfjsLib = window['pdfjs-dist/build/pdf'];
                pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';

                var pdfDoc = null,
                    pageNum = 1,
                    pageRendering = false,
                    pageNumPending = null,
                    scale = 0.8,
                    canvas = document.getElementById('pdf-canvas'),
                    ctx = canvas.getContext('2d');

                /**
                 * Get page info from document, resize canvas accordingly, and render page.
                 * @param num Page number.
                 */
                function renderPage(num) {
                    pageRendering = true;
                    // Using promise to fetch the page
                    pdfDoc.getPage(num).then(function (page) {
                        console.log('Scale is: ',scale);
                        var viewport = page.getViewport(scale);
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;

                        // Render PDF page into canvas context
                        var renderContext = {
                            canvasContext: ctx,
                            viewport: viewport
                        };
                        var renderTask = page.render(renderContext);

                        // Wait for rendering to finish
                        renderTask.promise.then(function () {
                            pageRendering = false;
                            if (pageNumPending !== null) {
                                // New page rendering is pending
                                renderPage(pageNumPending);
                                pageNumPending = null;
                            }
                        });
                    });

                    // Update page counters
                    document.getElementById('page_num').textContent = num;
                }

                /**
                 * If another page rendering in progress, waits until the rendering is
                 * finised. Otherwise, executes rendering immediately.
                 */
                function queueRenderPage(num) {
                    if (pageRendering) {
                        pageNumPending = num;
                    } else {
                        renderPage(num);
                    }
                }

                /**
                 * Displays previous page.
                 */
                function onPrevPage() {
                    if (pageNum <= 1) {
                        return;
                    }
                    pageNum--;
                    queueRenderPage(pageNum);
                }

                document.getElementById('prev').addEventListener('click', onPrevPage);

                /**
                 * Displays next page.
                 */
                function onNextPage() {
                    if (pageNum >= pdfDoc.numPages) {
                        return;
                    }
                    pageNum++;
                    queueRenderPage(pageNum);
                }

                function onZoomIn(){
                    scale = scale + 0.25;
                    queueRenderPage(pageNum);
                }

                function onZoomOut(){
                    scale = scale - 0.25;
                    queueRenderPage(pageNum);
                }

                document.getElementById('next').addEventListener('click', onNextPage);
                document.getElementById('zoomin').addEventListener('click', onZoomIn);
                document.getElementById('zoomout').addEventListener('click', onZoomOut);

                /**
                 * Asynchronously downloads PDF.
                 */
                pdfjsLib.getDocument(url).promise.then(function (pdfDoc_) {
                    pdfDoc = pdfDoc_;
                    document.getElementById('page_count').textContent = pdfDoc.numPages;

                    // Initial/first page rendering
                    renderPage(pageNum);
                });
            }
        },
        mounted() {
            var that = this;

            eventBus.$on('file-preview-modal-open', function (title, image, fileArrayKey, is_pdf) {
                that.title = title;
                that.image = image;
                that.fileArrayKey = fileArrayKey;
                that.is_pdf = is_pdf;
                that.openModal();
                if (is_pdf) {
                    setTimeout(function () {
                        that.setupPdf();
                    }, 100);
                }

                var checkThtKey = function (e) {
                    if (that.hidden) {
                        return;
                    }

                    e = e || window.event;
                    if (e.keyCode == '37') {
                        eventBus.$emit('file-preview-modal-previous', that.fileArrayKey);
                    } else if (e.keyCode == '39') {
                        eventBus.$emit('file-preview-modal-next', that.fileArrayKey);
                    }
                }

                window.setTimeout(function () {
                    document.onkeydown = checkThtKey;
                }, 500);

            });

            eventBus.$on('file-preview-modal-close', function () {
                that.closeModal();
                document.onkeydown = null;
            });

        }
    }
</script>

<style lang="scss" scoped>
    #pdf-canvas {
        margin: 0 auto;
        display: block;
    }
    .canvas-container{
        height: 92%;
        overflow:scroll;
        border: 2px solid #0088ce;
        border-radius: 0.3em;
        display: block;
    }

    .zoom-controls, .download-controls{
        display: inline-block;
        margin-left: 25px;
    }

    .pdf-controls {
        text-align: center;
        .page-numbers {
            font-size: 14px;
            text-align: center;
        }
        button {
            background-color: $brand;
        }
    }

    #file-preview-modal-container {
        display: none;
        &.opened {
            @include clearfix();
            background-color: #fff;
            position: absolute;
            height: 100vh;
            width: 100vw;
            z-index: 100000;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            top: 0;
            left: 0;
            @include desktop() {
                background: linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.85));
            }
            h1 {
                display: block;
                position: absolute;
                top: 1em;
                left: 1em;
                width: 100%;
            }
            .image-container {
                height: calc(100vh - 250px);
                width: 90%;
                margin-top: 80px;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
            }
            a {
                position: absolute;
                top: 0.4em;
                right: 1em;
                z-index: 10001;
                color: $brand;
                font-size: 25px;
            }
        }
    }
</style>
